// Story 10.5 — Helpers puros para los `beforeLoad` del router. Cada ruta
// protegida llama a `assertCapability` antes de cargar; si el user no
// matchea, el helper retorna la URL de redirect con `?error=forbidden`.

import { type Capability, hasPermission, type UserRole } from './permissions';

export interface ForbiddenRedirect {
  to: '/';
  search: { error: 'forbidden'; capability: Capability };
}

/**
 * Si `role` puede ejecutar `capability`, retorna `null`. Sino retorna el
 * payload para `throw redirect(...)`. El componente destino lee el search
 * param y dispara un toast.
 */
export function assertCapability(
  role: UserRole | null | undefined,
  capability: Capability,
): ForbiddenRedirect | null {
  if (hasPermission(role, capability)) return null;
  return {
    to: '/',
    search: { error: 'forbidden', capability },
  };
}

/**
 * Story 16.2 — igual que `assertCapability`, pero contra las capabilities que
 * el servidor devolvió para un recurso (un bot).
 */
export function assertCapabilityIn(
  capabilities: readonly Capability[],
  capability: Capability,
): ForbiddenRedirect | null {
  if (capabilities.includes(capability)) return null;
  return { to: '/', search: { error: 'forbidden', capability } };
}

/** Mensaje user-facing del toast de "forbidden". */
export function forbiddenMessage(capability: Capability | undefined): string {
  if (!capability) return 'No tienes permiso para acceder a esa vista.';
  return `No tienes permiso para "${capability.replace(/_/g, ' ')}".`;
}
